<template>
  <CoreDialog
    :value="value"
    size="sm"
    persistent
    no-click-animation
    :title="dialogContent.title"
    data-qa="analyses_lpu_cards_request_error_dialog"
    @input="emit('input', $event)"
  >
    <template #default>
      <div class="text-body-1 text-secondary--text">
        {{ dialogContent.text }}
      </div>
    </template>

    <template #actions>
      <v-btn
        color="primary"
        text
        data-qa="analyses_lpu_cards_request_error_reload"
        @click="reloadPage"
      >
        Обновить
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import { getAnalysesLpuRequestErrorDialog } from 'src/components/pages/[town-translit]/diagnostika/analiz/_functions/get-analyses-lpu-request-error-dialog'

const props = defineProps<{
  value: boolean
  error?: unknown
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()

const dialogContent = computed(() => getAnalysesLpuRequestErrorDialog(props.error))

function reloadPage() {
  if (!process.env.IS_CLIENT) {
    return
  }

  window.location.reload()
}
</script>
